














































































































































































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { usePageBase, useComponentBase } from '../../base';
import { Utils } from '../../helpers/utils';
import { ButtonProgress } from '../../components/button-progress';
import { isNullOrTodo } from '../../helpers/filters';
import { getStore } from '../../store';
import { useRouter } from '../../router';
import { copy } from '../../helpers';


const componentName = 'TextsEdit';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const pageBase = usePageBase();
        const componentBase = useComponentBase();

        const state = reactive({
            loaded: false,
            saveProgress: false,
            appVersionData: null,
            todoOnlySwitch: false,
            selectedLang: null,
            UISection: {
                id : null,
                name: null,
                doneCount: null,
                keysCount: null,
                keys: [],
                screens: []
            }
        });

        let UISectionOriginal: any = null;

        const onCreated = () => {
            componentBase.setLoading(true);

            state.appVersionData = store.state.appVersionSummary;
            state.selectedLang = "en";
            computeUISection(null);
            UISectionOriginal = copy(state.UISection);


            pageBase.setNavigation((nav) => {
                nav.push({ title: 'Apps', routerTo: { name: 'apps' }});
                nav.push({ title: `${state.appVersionData.name} ${state.appVersionData.platform}`, routerTo: { name: 'app-versions' }});
                nav.push({
                    title: `Version ${state.appVersionData.version} (Build ${state.appVersionData.build}) - ${lang.value}`,
                    routerTo: { name: 'app-version-summary' }
                });
                nav.push({ title: state.UISection.name });
            });

            state.loaded = true;

            componentBase.setLoading(false);
        }

        const lang = computed(() => route.value.params.lang);

        function getLangDirection(lang: string) {
            if (lang == 'ar') {
                return 'rtl';
            }
    
            return 'ltr';
        }

        const langDirection = computed(() => getLangDirection(lang.value));
        const selectedLangDirection = computed(() => getLangDirection(state.selectedLang));

        const onSave = async () => {
            state.saveProgress = true;

            let req = {
                versionId: state.appVersionData.versionId,
                keys: state.appVersionData.keys.filter(k => {
                        let kOriginal = UISectionOriginal.keys && UISectionOriginal.keys.find(x => x.id == k.id);
                        if (kOriginal && JSON.stringify(kOriginal.texts) != JSON.stringify(k.texts)) {
                            return true;
                        }
                        return false;
                    })
            };

            let res = await store.dispatch('updateKeys', {keys: req.keys });

            state.saveProgress = false;
            if (res) {
                store.commit('setUISnackbar', { type: 'success', message: 'Translations successfully saved.'});
                router.push({ name: 'app-version-summary' });
            }
            else {
                store.commit('setUISnackbar', { type: 'error', message: 'Error while saving data to the server. Try again.' });
            }
        }

        const computeUISection = (k: any) => {

            if (route.value.params.sectionId.toString() == '0') {
                state.UISection.id = 0;
                state.UISection.name = 'No section';
                state.UISection.doneCount = state.appVersionData.keys && state.appVersionData.keys.filter(k => (k.sectionId == null) && !isNullOrTodo(k.texts[lang.value])).length;
                state.UISection.keysCount = state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == null).length;
                state.UISection.keys = state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == null);
                state.UISection.screens = [ { id: null } ]
            }
            else {
                var s = state.appVersionData.sections && state.appVersionData.sections.find(x => x.id.toString() == route.value.params.sectionId);
                if (!s) {
                    return;
                }

                state.UISection.id = s.id;
                state.UISection.name = s.name;
                state.UISection.doneCount = state.appVersionData.keys && state.appVersionData.keys.filter(k => (k.sectionId == s.id) && !isNullOrTodo(k.texts[lang.value])).length;
                state.UISection.keysCount = state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == s.id).length;
                state.UISection.keys = state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == s.id);
                state.UISection.screens = s.screens
            }
        }

        const percentage = (done: number, total: number) => (total == 0) ? 0 : Math.floor((done / total) * 100);

        const completionColor = (perc: number) => Utils.getCompletionColor(perc);

        const screenshotKeys = (screenId : number, todoOnly: boolean) => {
            if (todoOnly) {
                return UISectionOriginal.keys.filter(x => (x.screenId != null) && (x.screenId == screenId) && isNullOrTodo(x.texts[lang.value]));;
            }
            else {
                return UISectionOriginal.keys.filter(x => (x.screenId != null) && x.screenId == screenId);
            }
        }

        const nonScreenshotKeys = (todoOnly: boolean) => {
            if (todoOnly) {
                return UISectionOriginal.keys.filter(x => (x.screenId == null) && isNullOrTodo(x.texts[lang.value]));
            }
            else {
                return UISectionOriginal.keys.filter(x => x.screenId == null);
            }
        }

        const getReactiveKeyFromOriginal = (kOriginal: any) => {
            return state.UISection.keys.find(k => k.id == kOriginal.id);
        }

        const getImagePath = (imageId : number) => {
            if (imageId) {
                return `/images/${imageId}/origin`;
            }
        }

        const languageName = computed(() => Utils.getLanguageName(lang.value));

        const languages = computed(() => state.appVersionData.appLanguages);

        onCreated();

        return {
            state,
            onSave,
            computeUISection,
            percentage,
            completionColor,
            screenshotKeys,
            nonScreenshotKeys,
            getImagePath,
            languageName,
            languages,
            lang,
            langDirection,
            selectedLangDirection,
            getReactiveKeyFromOriginal
        }
    },

    components: { ButtonProgress }
})

